export const getSettings = store => store.settings || {};
export const getAuth = store => store.auth || {};
export const getProjects = store => store.projects || {};
